"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cdn = _interopRequireDefault(require("../utils/cdn"));
var _lodash = _interopRequireDefault(require("lodash.assign"));
var _warn = _interopRequireDefault(require("../utils/warn"));
var _VideoTimeHelpers = _interopRequireDefault(require("./utils/VideoTimeHelpers"));
var _M3U8Utils = require("./utils/M3U8Utils.js");
var _eventEmitter = _interopRequireDefault(require("event-emitter"));
var _Logger = _interopRequireDefault(require("../logging/Logger"));
var _hudlUserTracking = require("hudl-user-tracking");
var _ActivityTrackingUtils = require("./utils/ActivityTrackingUtils");
var _CompatiblitiyTestingUtils = require("./utils/CompatiblitiyTestingUtils");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Module that provides the `BasePlayer` class.
 *
 * @module BasePlayer
 */
// eslint-disable-line no-unused-vars

var LOGGER_NAME = 'VPAnalyticsLogger';
var CDN_UNKNOWN_LABEL = 'UNKNOWN';
var CONTAINER_PREFIX = 'hudl-video-container';
var VIDEO_PREFIX = 'hudl-video-';
var LIVE_STATUS_POLL_INTERVAL_MILLIS = 4000;
var MAX_LIVE_STATUS_POLL_RETRY_DELAY_MILLIS = 300000; // 5 mins.

/**
 * Interface type class that provides the common API that individual players
 * should implement.
 *
 * @exports BasePlayer
 * @class BasePlayer
 */
var BasePlayer = exports["default"] = /*#__PURE__*/function () {
  /**
   * Create an instance of the TheoPlayer.
   * @param {InternalPlayerConfig} config - The player configuration object
   */
  function BasePlayer(config) {
    var _this = this;
    _classCallCheck(this, BasePlayer);
    _defineProperty(this, "_queueTransitionToNextClip", function () {
      // Do not seek in here. It destroys performance in Firefox
      _this.emit('timeupdate');
      if (_this.playables.length === _this.playingIndex + 1) {
        // Call onEnded if it is not going to hit the end of the current playable
        if (_this.currentPlayable.endTime) {
          _this.pause();
          _this._onEnded.call(_this, {
            internal: true
          });
        }
        return;
      }

      // Stop the activity tracker to ensure the playback heartbeat is emitted at
      // the end of the current playable
      _ActivityTrackingUtils.videoTrackingStop.call(_this);
      _this.playingIndex = _this.playingIndex + 1;
    });
    _defineProperty(this, "_setCdnInformation", function (cdnLabel) {
      _this.cdnInfo = cdnLabel;
      _this.cdnInfoFetched = true;
      _this.logger.sendCdnlessLogs();
    });
    (0, _lodash["default"])(this, _eventEmitter["default"].methods);

    // If config.logger is provided, it should be a constructor for
    // an object that matches the shape of the Logger class defined in
    // src/logging/Logger.js. This allows for overriding the default logger
    // behavior, for example in Hudl Insights (due to its offline nature)
    var LoggerClass = config.logger || _Logger["default"];
    this.rawPlayer = {};
    this.config = config;
    this.id = config.id;
    this.videoDOMId = "".concat(VIDEO_PREFIX).concat(this.id);
    this._autoAdvance = true;
    this._autoPlayClips = true;
    this._startCurrentTime = config.startCurrentTime || 0;
    this._previousCurrentTime = 0;
    this._livePollErrorCount = 0;
    this._expectedDuration = 0;
    this._transitionToNextClip = false;
    this.activityTracker = null;
    this.logger = new LoggerClass(LOGGER_NAME, this);

    // Video Activity Tracking event callbacks
    this._activityTrackingListenerMap = {
      'playing': _ActivityTrackingUtils.videoTrackingStart.bind(this),
      'pause': _ActivityTrackingUtils.videoTrackingStop.bind(this),
      'ended': _ActivityTrackingUtils.videoTrackingStop.bind(this),
      'waiting': _ActivityTrackingUtils.videoTrackingStop.bind(this),
      'seeking': _ActivityTrackingUtils.videoTrackingStop.bind(this),
      'error': _ActivityTrackingUtils.videoTrackingStop.bind(this),
      'timeupdate': _ActivityTrackingUtils.videoTrackingTimeUpdated.bind(this),
      'ratechange': _ActivityTrackingUtils.videoTrackingPlaybackRateChanged.bind(this)
    };
    this.logger.times = {
      DurationBitrate: 0
    };
    if (config.compatibilityTestCases && config.compatibilityTestCases.length > 0) {
      this._bindCompatibilityTestListener();
    }
    if (config.playables && config.playables.length > 0) {
      this.getCdnInformation(config.playables[0].src);
    }

    // Initialize the activity tracker if relevant configuration is present
    if ((0, _ActivityTrackingUtils.hasActivityTrackingEnabled)(config)) {
      var trackerConfigKey = config.activityTrackerOptions.config.trackerConfigKey;
      var trackerConfiguration = _objectSpread({
        globalSnowplowName: _ActivityTrackingUtils.GLOBAL_SNOWPLOW_NAME,
        trackerName: _ActivityTrackingUtils.TRACKER_NAME,
        trackerSettings: _ActivityTrackingUtils.defaultConfigs[trackerConfigKey],
        appVersion: _ActivityTrackingUtils.APP_VERSION
      }, config.activityTrackerOptions.config);

      // Get the event context based on the configuration and the initial playing index
      var context = (0, _ActivityTrackingUtils.getEventContext)(config, 0);
      this.activityTracker = new _hudlUserTracking.VideoActivitySnowplowTracker(trackerConfiguration, context);
      this._bindActivityTrackingEvents();
    }
    this.logger.times.LoadTimeScript = performance.now();
  }

  /**
   * Log warning message about unsupported property or method to the console if
   * `NODE_ENV` is not production.
   * @param {string} name - Property or method name
   * @param {boolean} isMethod - Whether to warn about a method or property
   * @private
   */
  return _createClass(BasePlayer, [{
    key: "_warnUsage",
    value: function _warnUsage(name, isMethod) {
      (0, _warn["default"])(name + (!isMethod ? ' property' : ' method') + ' is not supported with ' + this.name);
    }

    /**
     * Periodically called during player time change event.
    */
  }, {
    key: "_timeUpdated",
    value: function _timeUpdated() {}

    /**
     * Emit the timeupdate event whenever the player currentTime changes by
     * setting up a chained time out.
     * @private
     */
  }, {
    key: "_emitTimeUpdate",
    value: function _emitTimeUpdate() {
      var timeUpdateInterval = this.config.timeUpdateInterval;
      if (typeof timeUpdateInterval !== 'number' || timeUpdateInterval <= 0) {
        return;
      }
      var initialized = this.initialized,
        paused = this.paused,
        _transitionToNextClip = this._transitionToNextClip;
      if (!initialized || paused || _transitionToNextClip) {
        return;
      }
      this._transitionToNextClip = false;
      var timeUpdateIntervalSeconds = this.config.timeUpdateInterval / 1000;

      // we should only manually fire onEnded to start the transition IF the playable has an endTime
      // and it's before the duration of the video. If it's not, the rawPlayer tech will trigger the onEnded
      var currentTime = this.currentTime,
        _rawDuration = this._rawDuration,
        currentPlayable = this.currentPlayable,
        duration = this.duration;
      var hasEndBeforeDuration = currentPlayable && currentPlayable.endTime && currentPlayable.endTime <= _rawDuration;
      var durationIsNotZero = duration !== 0;
      var aboutToFlowOverEndTime = currentTime + timeUpdateIntervalSeconds > duration;
      if (hasEndBeforeDuration && durationIsNotZero && aboutToFlowOverEndTime) {
        setTimeout(this._onEnded.bind(this, {
          internal: true
        }), this.config.timeUpdateInterval);
        return;
      }
      this._timeUpdated();
      if (this.currentTime > 0 && this.currentTime !== this._previousCurrentTime) {
        this.emit('timeupdate');
        this._previousCurrentTime = this.currentTime;
      }
      clearTimeout(this._timeUpdateInterval);

      // do not do more time updates if we are switching clips
      if (!this._transitionToNextClip) {
        this._timeUpdateInterval = setTimeout(this._emitTimeUpdate.bind(this), timeUpdateInterval);
      }
    }
  }, {
    key: "_bindActivityTrackingEvents",
    value: function _bindActivityTrackingEvents() {
      var _this2 = this;
      if (!this.activityTracker) {
        return;
      }
      Object.keys(this._activityTrackingListenerMap).forEach(function (event) {
        _this2.addEventListener(event, _this2._activityTrackingListenerMap[event]);
      });
    }
  }, {
    key: "_cleanupActivityTracking",
    value: function _cleanupActivityTracking() {
      var _this3 = this;
      Object.keys(this._activityTrackingListenerMap).forEach(function (event) {
        _this3.removeEventListener(event, _this3._activityTrackingListenerMap[event]);
      });
      this.activityTracker = null;
    }

    /**
     * Polls on `player.src`,  and parses EXT-X-SESSION-DATA tags.
     *
     * @private
     */
  }, {
    key: "_pollLiveStreamAttributes",
    value: function _pollLiveStreamAttributes() {
      (0, _M3U8Utils.readSessionDataAttributesFromManifest)(this.src).then(function onRead(sessionDataAttributes) {
        if (sessionDataAttributes.expectedDuration && this.rawPlayer.expectedDuration !== sessionDataAttributes.expectedDuration) {
          this._expectedDuration = sessionDataAttributes.expectedDuration;
          this.emit('expecteddurationchange');
        }
        if (sessionDataAttributes.permanentManifestUri) {
          this._transitionToPermanentManifest(sessionDataAttributes.permanentManifestUri);
          return;
        }
        if (this.live) {
          this._livePollErrorCount = 0;
          this._liveStatusPollTimeout = setTimeout(this._pollLiveStreamAttributes.bind(this), LIVE_STATUS_POLL_INTERVAL_MILLIS);
        }
      }.bind(this), function onError(xhr) {
        // If we're still live,  and didn't get a flagged status that would indicate
        // the stream is down,  retry.
        if (this.live && [401, 403, 404, 410].indexOf(xhr.status) === -1) {
          this._liveStatusPollTimeout = setTimeout(this._pollLiveStreamAttributes.bind(this), Math.min(MAX_LIVE_STATUS_POLL_RETRY_DELAY_MILLIS, Math.pow(2, this._livePollErrorCount) * LIVE_STATUS_POLL_INTERVAL_MILLIS));
          this._livePollErrorCount++;
        }
      }.bind(this));
    }

    /**
     *  Assigns `player.src` to the VOD manifest uri provided while preserving
     *  play state.
     *
     * @private
     */
  }, {
    key: "_transitionToPermanentManifest",
    value: function _transitionToPermanentManifest(permanentManifestUri) {
      var wasPaused = this.paused;
      var currentTime = this.currentTime;
      this.src = permanentManifestUri;
      this.currentTime = currentTime;
      if (wasPaused) {
        this.pause();
      } else {
        this.play();
      }
    }
  }, {
    key: "_bindCompatibilityTestListener",
    value: function _bindCompatibilityTestListener() {
      this._compatibilityTester = true;
      this.addEventListener('initialized', _CompatiblitiyTestingUtils.runCompatibilityTest.bind(this));
    }
  }, {
    key: "_cleanupCompatibilityTestListener",
    value: function _cleanupCompatibilityTestListener() {
      this._compatibilityTester = null;
      this.removeEventListener('initialized', _CompatiblitiyTestingUtils.runCompatibilityTest.bind(this));
    }

    /**
     * Gets the CDN information for the video source.
     * @private
     */
  }, {
    key: "getCdnInformation",
    value: function getCdnInformation(src) {
      var _this4 = this;
      this.cdnInfo = CDN_UNKNOWN_LABEL;
      this.cdnInfoFetched = false;
      if (typeof src !== 'undefined' && src !== null) {
        return (0, _cdn["default"])(src).then(this._setCdnInformation)["catch"](function () {
          _this4._setCdnInformation(CDN_UNKNOWN_LABEL);
        });
      }
      return this.cdnInfo;
    }
  }, {
    key: "getVideoContainer",
    value:
    /**
     * Creates a wrapper element within specified `domNode` through the config if
     * one doesn't exist already.
     * @return {Object} - the wrapper DOM node that was attached to the video
     *                    container provided throught the config
     */
    function getVideoContainer() {
      var wrapper;
      if (!this._videoDOMWrapper) {
        wrapper = document.createElement('div');
        wrapper.id = "".concat(CONTAINER_PREFIX, "-").concat(this.config.id);
        wrapper.className = CONTAINER_PREFIX;
        this._videoDOMWrapper = wrapper;
        this.config.domNode.appendChild(wrapper);
      } else {
        wrapper = this._videoDOMWrapper;
      }
      return wrapper;
    }

    /**
     * Set the raw player for the BasePlayer.
     * @param {object} p - The player instance
     */
  }, {
    key: "setRawPlayer",
    value: function setRawPlayer(p) {
      this.rawPlayer = p;
    }

    /**
     * Adds an event listener for a particular event.
     * @param {string} event - The event to listen to
     * @param {function} callback - The callback to be run when the event occurs
     */
  }, {
    key: "addEventListener",
    value: function addEventListener(event, callback) {
      this.on(event, callback);
    }
  }, {
    key: "_onPlayerLoaded",
    value: function _onPlayerLoaded() {
      this._warnUsage('_onPlayerLoaded', true);
    }

    /**
     * Removes the player from the DOM and cleans up all resources.
     */
  }, {
    key: "destroy",
    value: function destroy() {
      // Each player should implement this method
      this._warnUsage('destroy', true);
    }

    /**
     * Play the player's video source.
     */
  }, {
    key: "play",
    value: function play() {
      this._warnUsage('play', true);
    }

    /**
     * Pause the player's video source.
     */
  }, {
    key: "pause",
    value: function pause() {
      this._warnUsage('pause', true);
    }

    /**
     * Returns the video aspectRatio if required information is available.
     * @type {number}
     */
  }, {
    key: "aspectRatio",
    get: function get() {
      this._warnUsage('aspectRatio');
      return null;
    }

    /**
     * Returns whether the video is configured to start playing automatically.
     * @type {boolean}
     */
  }, {
    key: "autoplay",
    get: function get() {
      this._warnUsage('autoplay');
      return null;
    }

    /**
     * Returns whether the player should automatically advance to the next clip.
     * @type {boolean}
     */,
    set:
    /**
     * Sets whether the video should start playing automatically on load.
     * @type {boolean}
     */
    function set(a) {
      // eslint-disable-line no-unused-vars
      this._warnUsage('autoplay');
    }

    /**
     * Get the player specific buffer information.
     * @type {object[]|number}
     */
  }, {
    key: "autoAdvance",
    get: function get() {
      this._warnUsage('autoAdvance');
      return null;
    }

    /**
     * Sets whether the player should automatically advance to the next clip.
     */,
    set: function set(a) {
      this._warnUsage('autoAdvance');
    }
  }, {
    key: "buffered",
    get: function get() {
      this._warnUsage('buffered');
      return null;
    }

    /**
     * Get the current frame number of the active video quality.
     * @type {number}
     */
  }, {
    key: "currentFrame",
    get: function get() {
      this._warnUsage('currentFrame');
      return null;
    }

    /**
     * Sets the current frame number, the player seeks to the given frame number
     * if `frameAccurateSeekEnabled` is true in the player configuration.
     * @type {number}
     */,
    set: function set(f) {
      // eslint-disable-line no-unused-vars
      this._warnUsage('currentFrame');
    }

    /**
     * Returns the currently playing video quality object.
     * @type {Quality}
     */
  }, {
    key: "currentQuality",
    get: function get() {
      this._warnUsage('currentQuality');
      return null;
    }

    /**
     * Set the quality for video playback using the video quality object specific
     * for each player.
     * @type {Quality}
     */,
    set: function set(q) {
      // eslint-disable-line no-unused-vars
      this._warnUsage('currentQuality');
    }

    /**
     * Get the manifest URL for the quality that is currently playing.
     * @type {string}
     */
  }, {
    key: "currentSrc",
    get: function get() {
      this._warnUsage('currentSrc');
      return null;
    }

    /**
     * Get the current playback position in the video (in seconds).
     * @type {number}
     */
  }, {
    key: "currentTime",
    get: function get() {
      this._warnUsage('currentTime');
      return null;
    }

    /**
     * Set the current playback position in the video (in seconds).
     * @type {number}
     */,
    set: function set(t) {
      // eslint-disable-line no-unused-vars
      this._warnUsage('currentTime');
    }

    /**
     * Get the length of the currently loaded video (in seconds), if available.
     * @type {number}
     */
  }, {
    key: "duration",
    get: function get() {
      this._warnUsage('duration');
      return null;
    }

    /**
     * Returns whether the video playback has ended or not.
     * @type {boolean}
     */
  }, {
    key: "ended",
    get: function get() {
      this._warnUsage('ended');
      return null;
    }

    /**
     * Returns an object representing the error state of the video.
     * @type {object}
     */
  }, {
    key: "error",
    get: function get() {
      this._warnUsage('error');
      return null;
    }

    /**
     * Returns whether the video player has frame accurate seeking enabled.
     * @type {boolean}
     */
  }, {
    key: "frameAccurateSeekEnabled",
    get: function get() {
      this._warnUsage('frameAccurateSeekEnabled');
      return null;
    }

    /**
     * Set the whether the player should enable frame accurate seeking.
     * @type {boolean}
     */,
    set: function set(t) {
      // eslint-disable-line no-unused-vars
      this._warnUsage('frameAccurateSeekEnabled');
    }

    /**
     * Returns whether the video player was initialized or not.
     * @type {boolean}
     */
  }, {
    key: "initialized",
    get: function get() {
      this._warnUsage('initialized');
      return null;
    }

    /**
     * Returns whether the video playback was paused or not.
     * @type {boolean}
     */
  }, {
    key: "paused",
    get: function get() {
      this._warnUsage('paused');
      return null;
    }

    /**
     * Returns the available qualities for the loaded video
     * @type {Quality[]}
     */
  }, {
    key: "qualities",
    get: function get() {
      this._warnUsage('qualities');
      return null;
    }

    /**
     * Returns whether the user is currently seeking in the video.
     * @type {boolean}
     */
  }, {
    key: "seeking",
    get: function get() {
      this._warnUsage('seeking');
      return null;
    }

    /**
     * Returns whether the audio output of the video is muted or not.
     * @type {boolean}
     */
  }, {
    key: "muted",
    get: function get() {
      this._warnUsage('muted');
      return null;
    }

    /**
     * Sets the state of the audio output to muted or not.
     * @type {boolean}
     */,
    set: function set(m) {
      // eslint-disable-line no-unused-vars
      this._warnUsage('muted');
    }

    /**
     * Returns the current source of the video player.
     * @type {string}
     */
  }, {
    key: "src",
    get: function get() {
      this._warnUsage('src');
      return null;
    }

    /**
     * Sets the current source for the video player.
     * @type {string}
     */,
    set: function set(s) {
      // eslint-disable-line no-unused-vars
      this._warnUsage('src');
    }

    /**
     * Returns the volume level of the audio output in the [0, 1] range.
     * @type {number}
     */
  }, {
    key: "volume",
    get: function get() {
      this._warnUsage('volume');
      return null;
    }

    /**
     * Sets the volume level of the audio output for the video.
     * @type {number}
     */,
    set: function set(v) {
      // eslint-disable-line no-unused-vars
      this._warnUsage('volume');
    }

    /**
     * Gets the playback rate of the video player.
     * @type {number}
     */
  }, {
    key: "playbackRate",
    get: function get() {
      this._warnUsage('playbackRate');
      return null;
    }

    /**
     * Sets the playback rate for the video player (e.g. `0.5`, `2.0`, `4.0`).
     * Note, normal playback rate has the value of `1.0`.
     * @type {number}
     */,
    set: function set(rate) {
      // eslint-disable-line no-unused-vars
      this._warnUsage('playbackRate');
    }

    /**
     * Gets the widht of the video player.
     * @type {number}
     */
  }, {
    key: "width",
    get: function get() {
      this._warnUsage('width');
      return null;
    }

    /**
     * Sets the width for the video player.
     * @type {number}
     */,
    set: function set(w) {
      // eslint-disable-line no-unused-vars
      this._warnUsage('width');
    }

    /**
     * Gets the height of the video player.
     * @type {number}
     */
  }, {
    key: "height",
    get: function get() {
      this._warnUsage('height');
      return null;
    }

    /**
     * Sets the height for the video player.
     * @type {number}
     */,
    set: function set(h) {
      // eslint-disable-line no-unused-vars
      this._warnUsage('height');
    }

    /**
     * Checks if the video player supports slow rewind.
     * @type {boolean}
     */
  }, {
    key: "canPlaySlowBackward",
    get: function get() {
      this._warnUsage('canPlaySlowBackward');
      return null;
    }

    /**
     * Checks if the video player supports fast rewind.
     * @type {boolean}
     */
  }, {
    key: "canPlayFastBackward",
    get: function get() {
      this._warnUsage('canPlayFastBackward');
      return null;
    }

    /**
     * Checks if the video player supports slow forward playback.
     * @type {boolean}
     */
  }, {
    key: "canPlaySlowForward",
    get: function get() {
      this._warnUsage('canPlaySlowForward');
      return null;
    }

    /**
     * Checks if the video player supports fast forward playback.
     * @type {boolean}
     */
  }, {
    key: "canPlayFastForward",
    get: function get() {
      this._warnUsage('canPlayFastForward');
      return null;
    }

    /**
     * Checks if the video player supports frame accurate seeking.
     * @type {boolean}
     */
  }, {
    key: "canSeekByFrame",
    get: function get() {
      this._warnUsage('canSeekByFrame');
      return null;
    }

    /**
     * Returns true if the stream is live,  false otherwise.
     * @type {boolean}
     */
  }, {
    key: "live",
    get: function get() {
      return this.rawPlayer.live;
    }

    /**
     * Relevant to live streams,  returns the anticipated final duration of the
     * stream after encoding has finished.  Will never be less than `duration`.
     * On VOD streams,  it will be equal to `duration`.
     * @type {number}
     */
  }, {
    key: "expectedDuration",
    get: function get() {
      if (!this.currentPlayable) return 0;
      var duration = _VideoTimeHelpers["default"].getDuration(this.currentPlayable, this.duration);
      if (this.live) {
        return Math.max(this._expectedDuration, duration);
      }
      return duration;
    }
  }, {
    key: "playingIndex",
    get: function get() {
      this._warnUsage('playingIndex');
      return null;
    },
    set: function set(i) {
      this._warnUsage('playingIndex', i);
      return null;
    }
  }, {
    key: "playables",
    get: function get() {
      this._warnUsage('playables');
      return null;
    },
    set: function set(p) {
      this._warnUsage('playables', p);
      return null;
    }

    /**
     * @param {boolean} h
     */
  }, {
    key: "hideSpinner",
    set: function set(h) {
      this._warnUsage('hideSpinner', h);
      return null;
    }
  }]);
}();